<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("gestionDeGastos") }}
            </li>
          </ol>
        </nav>
      </div>

      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label for="listBusiness"><strong>{{ $t("negocio") }}</strong></label>

                <el-select class="select-default" size="large" v-model="idBusiness" filterable
                  @change="cambiarNegocio()" :placeholder="listBusinesses.length === 0 ? 'Obteniendo negocios...' : $t('seleccionaNegocio')">
                  <el-option v-for="business in listBusinesses" class="select-primary" :value="business.id"
                    :label="business.establishmentName" :key="business.establishmentName">
                  </el-option>
                </el-select>
              </div>
            </div>

            <template v-if="permiso">
              <div class="col-md-3">
                <div class="form-group">
                  <label for="listBusiness"><strong>{{ $t("proveedores") }}</strong></label>

                  <el-select class="select-default" size="large" v-model="idSupplier" filterable
                    :placeholder="$t('seleccionaProveedor')" @change="handleFilterChange()">
                    <el-option v-for="su in listProveedores" class="select-primary" :value="su.id" :label="su.name"
                      :key="su.id">
                    </el-option>
                  </el-select>
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label>{{ $t("fechaInicio") }}</label>
                  <datetime :value-zone="timezoneId" :auto="true" class="theme-numier" format="dd-MM-yyyy"
                    :title="$t('fechaInicio')" :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                    input-class="form-control" v-model="datefrom"></datetime>
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label>{{ $t("fechaFin") }}</label>
                  <datetime :auto="true" class="theme-numier" :value-zone="timezoneId" :title="$t('fechaFin')"
                    format="dd-MM-yyyy" :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }" input-class="form-control"
                    v-model="dateto"></datetime>
                </div>
              </div>

              <div class="col-md-2">
                <label>&nbsp;</label>
                <div class="form-group" style="margin-bottom: 10px">
                  <button class="btn btn-primary btn-responsive-block" @click="getGastosNegocio()" :disabled="listBusinesses.length === 0 || (loadingBusinessId === idBusiness && loadingResults)">
                    <i v-if="loadingBusinessId === idBusiness && loadingResults" class="fa fa-refresh fa-spin"></i>
                    <i v-else class="fa fa-search"></i>
                    <span>{{ (loadingBusinessId === idBusiness && loadingResults) ? 'Consultando...' : $t("consultar") }}</span>
                  </button>
                </div>

                <div class="form-group">
                  <el-checkbox v-model="filtrarPorFecha">{{ $t("filtrarPorFecha") }}
                    <i v-tooltip.top-center="'Si esta opción está activada, filtrará por dias naturales, no por fecha de apertura de caja.'
                      " class="fa fa-info-circle"></i>
                  </el-checkbox>
                </div>
              </div>

              <div class="col-md-4">
                <label><strong>{{ $t("procedencia") }}</strong></label>
                <div class="form-group">
                  <el-radio @change="handleFilterChange()" v-model="procedencia" :label="2">
                    {{ $t("todos") }}
                  </el-radio>
                  <el-radio @change="handleFilterChange()" v-model="procedencia" :label="1">
                    {{ $t("deCaja") }}
                  </el-radio>
                  <el-radio @change="handleFilterChange()" v-model="procedencia" :label="0">
                    {{ $t("fueraDeCaja") }}
                  </el-radio>
                </div>
              </div>

              <div class="col-md-4">
                <label><strong>{{ $t("tipo") }}</strong></label>
                <div class="form-group">
                  <el-radio @change="handleFilterChange()" v-model="tipo" :label="0">{{ $t("todos") }}
                  </el-radio>
                  <el-radio @change="handleFilterChange()" v-model="tipo" label="A">{{ $t("albaran") }}
                  </el-radio>
                  <el-radio @change="handleFilterChange()" v-model="tipo" label="F">{{ $t("factura") }}
                  </el-radio>
                </div>
              </div>

              <div class="col-md-4">
                <label><strong>{{ $t("contabilizado") }}</strong></label>
                <div class="form-group">
                  <el-radio @change="handleFilterChange()" v-model="contabilizado" :label="-1">
                    {{ $t("todos") }}
                  </el-radio>
                  <el-radio @change="handleFilterChange()" v-model="contabilizado" :label="1">
                    {{ $t("si") }}
                  </el-radio>
                  <el-radio @change="handleFilterChange()" v-model="contabilizado" :label="0">
                    {{ $t("no") }}
                  </el-radio>
                </div>
              </div>

              <div class="col-md-6">
                <label><strong>{{ $t("formaDePago") }}</strong></label>
                <div class="form-group">
                  <el-radio @change="handleFilterChange()" v-model="formaPago" :label="-1">{{ $t("todos") }}
                  </el-radio>
                  <el-radio @change="handleFilterChange()" v-model="formaPago" :label="0">
                    {{ $t("transferencia") }}
                  </el-radio>
                  <el-radio @change="handleFilterChange()" v-model="formaPago" :label="1">
                    {{ $t("domiciliacion") }}
                  </el-radio>
                  <el-radio @change="handleFilterChange()" v-model="formaPago" :label="2">
                    {{ $t("efectivo") }}
                  </el-radio>
                  <el-radio @change="handleFilterChange()" v-model="formaPago" :label="3">
                    {{ $t("tarjeta") }}
                  </el-radio>
                </div>
              </div>

              <div class="col-md-3">
                <label><strong>{{ $t("pendientePago") }}</strong></label>
                <div class="form-group">
                  <el-radio @change="handleFilterChange()" v-model="pendientePago" :label="-1">
                    {{ $t("todos") }}
                  </el-radio>
                  <el-radio @change="handleFilterChange()" v-model="pendientePago" :label="true">
                    {{ $t("si") }}
                  </el-radio>
                  <el-radio @change="handleFilterChange()" v-model="pendientePago" :label="false">
                    {{ $t("no") }}
                  </el-radio>
                </div>
              </div>

              <div class="col-md-3">
                <label><strong>{{ $t("verificado") }}</strong></label>
                <div class="form-group">
                  <el-radio @change="handleFilterChange()" v-model="verificado" :label="-1">
                    {{ $t("todos") }}
                  </el-radio>
                  <el-radio @change="handleFilterChange()" v-model="verificado" :label="1">
                    {{ $t("si") }}
                  </el-radio>
                  <el-radio @change="handleFilterChange()" v-model="verificado" :label="0">
                    {{ $t("no") }}
                  </el-radio>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <template v-if="!permiso">
        <div class="alert alert-danger m-3" style="width: 100%" role="alert">
          Lo sentimos. Este negocio no cuenta con este módulo activado.
        </div>
      </template>
      <div class="col-md-12" v-else-if="respuesta">
        <div class="card">
          <template>
            <div class="row justify-content-between div-export">
              <div class="col-md-8 text-left">
                <div class="form-group">
                  <router-link :to="{
                    name: 'gestion-gasto',
                    params: { idBusiness: this.idBusiness },
                  }" :event="listBusinesses.length === 0 ? '' : 'click'">
                    <button class="btn btn-primary" :disabled="listBusinesses.length === 0">
                      <i class="fa fa-plus-square"></i>
                      {{ $t("agregarGasto") }}
                    </button>
                  </router-link>
                  <button v-if="!convertirAlbaranes && list.length > 0" class="btn btn-warning"
                    @click="convertirAlbaranes = true">
                    <i class="fas fa-random"></i>
                    {{ $t("convertirAlbaranes") }}
                  </button>
                  <button v-if="convertirAlbaranes && listConvertir.length > 0" class="btn btn-success"
                    @click="openModalConvertirAlbaran()">
                    <i class="fas fa-random"></i>
                    {{ $t("convertirAlbaranes") }}
                  </button>
                  <button v-if="convertirAlbaranes" class="btn btn-danger" @click="
                    (convertirAlbaranes = false),
                    (listConvertir = []),
                    (idSupplierConvertir = 0)
                    ">
                    <i class="fas fa-undo"></i>
                    {{ $t("cancelarConversion") }}
                  </button>
                  <button v-if="convertirAlbaranes && listConvertir.length > 0" class="btn btn-info active"
                    @click="seleccionarTodosAlbaranes()">
                    <i class="fa fa-minus-square"></i>
                    {{ $t("seleccionarTodosDelMismoProveedor") }}
                  </button>
                  <button v-if="!convertirAlbaranes" class="btn btn-info active"
                    :disabled="verificandoTodos || listBusinesses.length === 0"
                    @click="verificarTodo()">
                    <i v-if="verificandoTodos" class="fa fa-spinner fa-spin"></i>
                    <i v-else class="fas fa-check"></i>
                    {{ $t("verificarTodo") }}
                  </button>
                  <button v-if="identificadorContable" class="btn btn-info" @click="openConModal()">
                    <i class="fa fa-file"></i>
                    {{ $t("exportarContabilidad") }}
                  </button>
                </div>
              </div>

              <div v-if="list.length > 0" class="col-md-2 col-xs-12 text-right">
                <el-dropdown>
                  <el-button type="primary" size="small">
                    <i class="fa fa-file"></i>
                    {{ $t("exportarInforme") }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <a :href="urlExportPDF">
                      <el-dropdown-item class="text-danger">
                        <strong><i class="fa fa-file-pdf"></i>
                          {{ $t("exportarPdf") }}</strong>
                      </el-dropdown-item>
                    </a>
                    <a :href="urlExportExcel">
                      <el-dropdown-item class="text-success">
                        <strong><i class="fa fa-file-excel"></i>
                          {{ $t("exportarExcel") }}</strong>
                      </el-dropdown-item>
                    </a>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>

            <div v-if="list.length > 0" class="table-scroll-top" ref="tableScrollTop" @scroll="onTopScroll">
              <div class="table-scroll-top-inner" ref="tableScrollTopInner"></div>
            </div>
            <div v-if="list.length > 0" class="table-responsive" ref="tableResponsive" @scroll="onBottomScroll">
              <table class="table table-bordered table-striped">
                <thead class="thead-dark">
                  <tr>
                    <!--NUEVOS CAMPOS-->
                    <th>
                      <span v-if="ordenarNombreTpv" @click="sortedArrayASC(10), (ordenarNombreTpv = 0)"><i
                          style="color: white" class="fa fa-angle-up"></i> Tpv
                      </span>
                      <span v-else @click="sortedArrayDESC(10), (ordenarNombreTpv = 1)"><i style="color: white"
                          class="fa fa-angle-down"></i>
                        Tpv
                      </span>
                    </th>

                    <th>
                      <span v-if="ordenarNombreOperario" @click="sortedArrayASC(11), (ordenarNombreOperario = 0)"><i
                          style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("operario") }}
                      </span>
                      <span v-else @click="
                        sortedArrayDESC(11), (ordenarNombreOperario = 1)
                        "><i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("operario") }}
                      </span>
                    </th>

                    <!--FIN NUEVOS CAMPOS-->

                    <th>
                      <span v-if="ordenarFecha" @click="sortedArrayASC(1), (ordenarFecha = 0)"><i style="color: white"
                          class="fa fa-angle-up"></i>
                        {{ $t("fecha") }}
                      </span>
                      <span v-else @click="sortedArrayDESC(1), (ordenarFecha = 1)"><i style="color: white"
                          class="fa fa-angle-down"></i>
                        {{ $t("fecha") }}
                      </span>
                    </th>
                    <th>
                      <span v-if="ordenarProveedor" @click="sortedArrayASC(2), (ordenarProveedor = 0)"><i
                          style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("proveedor") }}
                      </span>
                      <span v-else @click="sortedArrayDESC(2), (ordenarProveedor = 1)"><i style="color: white"
                          class="fa fa-angle-down"></i>
                        {{ $t("proveedor") }}
                      </span>
                    </th>
                    <th>
                      <span v-if="ordenarBase" @click="sortedArrayASC(3), (ordenarBase = 0)"><i style="color: white"
                          class="fa fa-angle-up"></i>
                        {{ $t("base") }}
                      </span>
                      <span v-else @click="sortedArrayDESC(3), (ordenarBase = 1)"><i style="color: white"
                          class="fa fa-angle-down"></i>
                        {{ $t("base") }}
                      </span>
                    </th>
                    <th>
                      <span v-if="ordenarImporteIVA" @click="sortedArrayASC(12), (ordenarImporteIVA = 0)"><i
                          style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("importeIVA") }}
                      </span>
                      <span v-else @click="sortedArrayDESC(12), (ordenarImporteIVA = 1)"><i style="color: white"
                          class="fa fa-angle-down"></i>
                        {{ $t("importeIVA") }}
                      </span>
                    </th>
                    <th>
                      <span v-if="ordenarImporte" @click="sortedArrayASC(4), (ordenarImporte = 0)"><i
                          style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("importe") }}
                      </span>
                      <span v-else @click="sortedArrayDESC(4), (ordenarImporte = 1)"><i style="color: white"
                          class="fa fa-angle-down"></i>
                        {{ $t("importe") }}
                      </span>
                    </th>
                    <th v-if="list.some(item => item.baseSinDto && item.baseSinDto > 0)">
                      <span v-if="ordenarBaseSinDto" @click="sortedArrayASC(17), (ordenarBaseSinDto = 0)"><i
                          style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("baseSinDto") }}
                      </span>
                      <span v-else @click="sortedArrayDESC(17), (ordenarBaseSinDto = 1)"><i style="color: white"
                          class="fa fa-angle-down"></i>
                        {{ $t("baseSinDto") }}
                      </span>
                    </th>
                    <th v-if="list.some(item => item.importeTotalSinDto && item.importeTotalSinDto > 0)">
                      <span v-if="ordenarImporteTotalSinDto" @click="sortedArrayASC(18), (ordenarImporteTotalSinDto = 0)"><i
                          style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("importeTotalSinDto") }}asdasdasd
                      </span>
                      <span v-else @click="sortedArrayDESC(18), (ordenarImporteTotalSinDto = 1)"><i style="color: white"
                          class="fa fa-angle-down"></i>
                        {{ $t("importeTotalSinDto") }}
                      </span>
                    </th>
                    <th v-if="identificadorContable">
                      <span v-if="ordenarId" @click="sortedArrayASC(13), (ordenarId = 0)"><i style="color: white"
                          class="fa fa-angle-up"></i>
                        {{ $t("identificador") }}
                      </span>
                      <span v-else @click="sortedArrayDESC(13), (ordenarId = 1)"><i style="color: white"
                          class="fa fa-angle-down"></i>
                        {{ $t("identificador") }}
                      </span>
                    </th>
                    <th>
                      <span v-if="ordenarReferencia" @click="sortedArrayASC(5), (ordenarReferencia = 0)"><i
                          style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("referencia") }}
                      </span>
                      <span v-else @click="sortedArrayDESC(5), (ordenarReferencia = 1)"><i style="color: white"
                          class="fa fa-angle-down"></i>
                        {{ $t("referencia") }}
                      </span>
                    </th>
                    <th>
                      <span v-if="ordenarTipo" @click="sortedArrayASC(6), (ordenarTipo = 0)"><i style="color: white"
                          class="fa fa-angle-up"></i>
                        {{ $t("tipo") }}
                      </span>
                      <span v-else @click="sortedArrayDESC(6), (ordenarTipo = 1)"><i style="color: white"
                          class="fa fa-angle-down"></i>
                        {{ $t("tipo") }}
                      </span>
                    </th>
                    <th>
                      <span v-if="ordenarProcedencia" @click="sortedArrayASC(7), (ordenarProcedencia = 0)"><i
                          style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("procedencia") }}
                      </span>
                      <span v-else @click="sortedArrayDESC(7), (ordenarProcedencia = 1)"><i style="color: white"
                          class="fa fa-angle-down"></i>
                        {{ $t("procedencia") }}
                      </span>
                    </th>
                    <th>
                      <span v-if="ordenarFormaDePago" @click="sortedArrayASC(8), (ordenarFormaDePago = 0)"><i
                          style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("formaDePago") }}
                      </span>
                      <span v-else @click="sortedArrayDESC(8), (ordenarFormaDePago = 1)"><i style="color: white"
                          class="fa fa-angle-down"></i>
                        {{ $t("formaDePago") }}
                      </span>
                    </th>
                    <th>
                      <span v-if="ordenarEntrAlmac" @click="sortedArrayASC(16), (ordenarEntrAlmac = 0)"><i
                          style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("entrAlmac") }}
                      </span>
                      <span v-else @click="sortedArrayDESC(16), (ordenarEntrAlmac = 1)"><i style="color: white"
                          class="fa fa-angle-down"></i>
                        {{ $t("entrAlmac") }}
                      </span>
                    </th>
                    <th>
                      <span v-if="ordenarContab" @click="sortedArrayASC(9), (ordenarContab = 0)"><i style="color: white"
                          class="fa fa-angle-up"></i>
                        {{ $t("contab") }}.
                      </span>
                      <span v-else @click="sortedArrayDESC(9), (ordenarContab = 1)"><i style="color: white"
                          class="fa fa-angle-down"></i>
                        {{ $t("contab") }}.
                      </span>
                    </th>
                    <th>
                      <span v-if="ordenarPago" @click="sortedArrayASC(14), (ordenarPago = 0)"><i style="color: white"
                          class="fa fa-angle-up"></i>
                      </span>
                      <span v-else @click="sortedArrayDESC(14), (ordenarPago = 1)"><i style="color: white"
                          class="fa fa-angle-down"></i>
                      </span>
                      {{ $t("pendientePago") }}
                    </th>
                    <th>
                      <span v-if="ordenarVencimiento" @click="sortedArrayASC(15), (ordenarVencimiento = 0)"><i
                          style="color: white" class="fa fa-angle-up"></i>
                      </span>
                      <span v-else @click="sortedArrayDESC(15), (ordenarVencimiento = 1)"><i style="color: white"
                          class="fa fa-angle-down"></i>
                      </span>
                      {{ $t("fechaVencimiento") }}
                    </th>
                    <th>{{ $t("acciones") }}</th>
                    <th v-if="tieneSage">{{ $t("exportadoSage") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="obj in list">
                    <!--NUEVOS CAMPOS-->
                    <td style="width: 10%">{{ obj.nombreTpv }}</td>

                    <!--FIN NUEVOS CAMPOS-->
                    <td style="width: 10%">{{ obj.nombreOperario }}</td>

                    <td style="width: 10%">
                      <span v-if="obj.fromCash !== 1">{{
                        obj.date | parseDate
                      }}</span><span v-else>{{ obj.date | parseDateMin }}</span>
                    </td>
                    <td>{{ obj.supplierName }}</td>
                    <td align="right" style="width: 10%">
                      {{ obj.base | currency }}
                    </td>
                    <td align="right" style="width: 10%">
                      {{ obj.importeIVA | currency }}
                    </td>
                    <td align="right" style="width: 10%">
                      {{ obj.price | currency }}
                    </td>
                    <td v-if="list.some(item => item.baseSinDto && item.baseSinDto > 0)" align="right"
                      style="width: 10%">
                      {{ obj.baseSinDto | currency }}
                    </td>
                    <td v-if="list.some(item => item.importeTotalSinDto && item.importeTotalSinDto > 0)" align="right"
                      style="width: 10%">
                      {{ obj.importeTotalSinDto | currency }}
                    </td>
                    <td v-if="identificadorContable">
                      {{ obj.identificador }}
                    </td>
                    <td>{{ obj.ref }}</td>
                    <td>
                      <span v-if="obj.type === 'F'">{{ $t("factura") }}</span>
                      <span v-else>{{ $t("albaran") }}</span>
                    </td>
                    <td>
                      <span v-if="obj.fromCash === 1">{{ $t("deCaja") }}</span>
                      <span v-else>{{ $t("fueraDeCaja") }} </span>
                    </td>
                    <td>
                      <span v-if="obj.formaPago === 0">{{
                        $t("tranferencia")
                      }}</span>
                      <span v-else-if="obj.formaPago === 1">{{
                        $t("domiciliacion")
                      }}</span>
                      <span v-else-if="obj.formaPago === 3">{{
                        $t("tarjeta")
                      }}</span>
                      <span v-else>{{ $t("efectivo") }}</span>
                    </td>
                    <td align="center">
                      <button class="btn btn-secondary" @click="openInventario(obj.idHeader)"
                        v-if="obj.generateWarehouse == 1" v-tooltip.top-center="$i18n.t('detallesDeLaentradaEnAlmacen')
                          ">
                        <i class="fas fa-boxes text-warning"></i>
                        {{ $t("ver") }}
                      </button>
                    </td>

                    <td class="text-center" :class="{ cursor: obj.fromCash == 0 }">
                      <span @click="contabilizar(obj)" v-if="obj.contabilizado === 0">
                        <i class="fas fa-times text-danger"></i> {{ $t("no") }}
                      </span>
                      <span @click="contabilizar(obj)" v-else>
                        <i class="fas fa-check text-success"></i> {{ $t("si") }}
                      </span>
                    </td>

                    <td class="text-center" :class="{ cursor: obj.fromCash == 0 }">
                      <span @click="pagar(obj)" v-if="obj.pendientePago === false">
                        <i class="fas fa-times text-danger"></i> {{ $t("no") }}
                      </span>
                      <span @click="pagar(obj)" v-else>
                        <i class="fas fa-check text-success"></i> {{ $t("si") }}
                      </span>
                    </td>

                    <td>
                      <template v-if="obj.editVencimiento === false">
                        <div class="d-flex align-items-center justify-content-around">
                          <span v-if="parseInt(obj.dateVencimiento) > 0">
                            {{ obj.dateVencimiento | parseDate }}
                          </span>
                          <span v-else>
                            <i class="fa-solid fa-minus"></i>
                          </span>
                          <i @click="editarVencimiento(obj)" class="fa-solid fa-pencil" style="color: orange"></i>
                        </div>
                      </template>
                      <div class="d-flex align-items-center" v-else>
                        <div>
                          <datetime :value-zone="timezoneId" :auto="true" class="theme-numier" format="dd-MM-yyyy"
                            :title="$t('fechaVencimiento')" :phrases="{
                              ok: $t('aceptar'),
                              cancel: $t('salir'),
                            }" input-class="form-control" v-model="fechaVencimiento"></datetime>
                        </div>
                        <i @click="saveVencimiento(obj)" class="fa-solid fa-floppy-disk text-success"></i>
                      </div>
                    </td>

                    <td class="text-center">
                      <div>
                        <template v-if="obj.fromCash == 0">
                          <i v-tooltip.top-center="'Este gasto fue marcado para no generar movimiento en almacén' " v-if="obj.noCuentaStock == 1 && obj.generateWarehouse == 0 && !obj.idGastoCab" class="fas fa-ban text-muted"></i>
                          <i v-tooltip.top-center="'Este gasto fue anterior al último inventario cerrado en ese momento: se registró el movimiento en almacén, pero no se actualizaron las cantidades de stock.' " v-else-if="obj.noCuentaStock == 1 && obj.tieneMovimientoAlmacen === true && !obj.idGastoCab" class="fas fa-question-circle text-muted"></i>
                          <i v-tooltip.top-center="'Este gasto no ha generado movimiento en almacén' " v-else-if="obj.noCuentaStock == 1 && !obj.idGastoCab" class="fas fa-exclamation-circle"></i>
                          <template v-if="obj.verificado === 1">
                            <div class="d-flex align-items-center justify-content-center" style="gap: 20px">
                              <span class="text-success cursor">
                                <i v-tooltip.top-center="'Verificado'" class="fas fa-check"></i>
                              </span>
                              <span v-if="obj.generateWarehouse == 1" class="text-success cursor"
                                @click="rutas(3, obj)">
                                <i v-tooltip.top-center="'Modificar precio'"
                                  class="fa-solid fa-pencil text-warning"></i>
                              </span>
                            </div>

                            <template v-if="obj.type === 'A'">
                              <template v-if="
                                convertirAlbaranes &&
                                (obj.supplierId === idSupplierConvertir ||
                                  idSupplierConvertir === 0)
                              ">
                                <el-checkbox-group v-model="listConvertir">
                                  <el-checkbox @change="accion(obj.supplierId)" :label="obj.idHeader">{{ $t("convertir") }}
                                  </el-checkbox>
                                </el-checkbox-group>
                              </template>
                            </template>
                            <div class="btn btn-primary btn-link" v-if="obj.idGastoCab">
                              <span v-tooltip.top-center="'Ver albaranes de la factura'
                                " @click="openModalAlbaranesFactura(obj.idCab)">
                                <i class="far fa-eye"></i>
                              </span>
                            </div>
                          </template>
                          <el-dropdown v-else trigger="click">
                            <el-button type="secondary" size="medium">
                              <i class="fas fa-cog"></i>
                              {{ $t("acciones") }}
                              <i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item :disabled="!!procesando[obj.idHeader]"
                                @click.native="!procesando[obj.idHeader] && modalverificar(obj)">
                                <i class="fas fa-check text-success"></i>
                                {{ $t("verificar") }}
                                <i v-if="obj.generateWarehouse != 1"
                                  style="margin-left: 8px;"
                                  v-tooltip.top-center="'Al verificar este gasto no se generará movimiento de almacén'"
                                  class="fas fa-info-circle text-muted"></i>
                              </el-dropdown-item>

                              <el-dropdown-item :disabled="!!procesando[obj.idHeader]"
                                @click.native="!procesando[obj.idHeader] && rutas(2, obj)">
                                <i class="fas fa-cog text-warning"></i>
                                {{ $t("modificar") }}
                              </el-dropdown-item>
                              <el-dropdown-item :disabled="!!procesando[obj.idHeader]"
                                @click.native="!procesando[obj.idHeader] && modaleliminar(obj)">
                                <i class="fas fa-minus-circle text-danger"></i>
                                {{ $t("eliminar") }}
                              </el-dropdown-item>
                            </el-dropdown-menu>
                          </el-dropdown>
                        </template>
                        <template v-else>
                          <div class="d-flex align-items-center justify-content-center" style="gap: 20px">
                            <span class="text-success cursor">
                              <i v-tooltip.top-center="'Verificado'" class="fas fa-check"></i>
                            </span>
                            <span v-if="obj.generateWarehouse == 1" class="text-success cursor" @click="rutas(3, obj)">
                              <i v-tooltip.top-center="'Modificar precio'" class="fa-solid fa-pencil text-warning"></i>
                            </span>
                          </div>
                        </template>
                      </div>
                    </td>
                    <template v-if="tieneSage">
                      <td class="text-center" :class="{ cursor: obj.fromCash == 0 }">
                        <span @click="updateExportadoSage(obj)" v-if="obj.exportadoSage === 0">
                          <i class="fas fa-times text-danger"></i>
                          {{ $t("no") }}
                        </span>
                        <span @click="updateExportadoSage(obj)" v-else>
                          <i class="fas fa-check text-success"></i>
                          {{ $t("si") }}
                        </span>
                      </td>
                    </template>
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="table-success">
                    <td>
                      <strong>{{ $t("total") }}</strong>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="text-right">
                      <strong>{{ getTotalBase | currency }}</strong>
                    </td>
                    <td></td>
                    <td class="text-right">
                      <strong>{{ getTotalPrecio | currency }}</strong>
                    </td>
                    <td v-if="list.some(item => item.baseSinDto && item.baseSinDto > 0)" class="text-right">
                      <strong>{{ getTotalBaseSinDto | currency }}</strong>
                    </td>
                    <td v-if="list.some(item => item.importeTotalSinDto && item.importeTotalSinDto > 0)" class="text-right">
                      <strong>{{ getTotalImporteTotalSinDto | currency }}</strong>
                    </td>
                    <td></td>
                    <td></td>
                    <td v-if="identificadorContable"></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td v-if="tieneSage"></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </template>
          <template v-if="list.length === 0">
            <div v-if="loadingBusinessId === idBusiness && loadingResults" class="alert alert-warning">
              <i class="fa fa-spinner fa-spin"></i>
              {{ $t("cargandoDatos") }}...
            </div>
            <div v-else-if="!searchPerformed" class="alert" style="background: linear-gradient(135deg, #34495e 0%, #2c3e50 100%); color: #ecf0f1;">
              {{ $t("clickConsultarParaRealizarBusqueda") }}
            </div>
            <div v-else class="alert alert-danger" role="alert">
              {{ $t("noHay") }} <strong>{{ $t("gastos") }}</strong>
              {{ $t("rangoDeFechas") }}
            </div>
          </template>
        </div>
      </div>
    </div>

    <modal name="modal-open-inventario" :adaptive="true" width="900px" :scrollable="true" height="auto"
      :clickToClose="true">
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("entradaAlmacen") }}</h4>
        </div>
        <div class="modal-body">
          <div>
            <div v-if="inventario.subproducts.length > 0" class="table-responsive">
              <div class="checkbox">
                <label v-if="inventario.ivaIncluded == 0">
                  <input type="checkbox" disabled />
                  {{ $t("preciosIVAIncluido") }}
                </label>
                <label v-else>
                  <input type="checkbox" disabled checked />
                  {{ $t("preciosIVAIncluido") }}
                </label>
              </div>

              <table class="table table-bordered table-striped">
                <thead class="thead-dark">
                  <tr>
                    <th>{{ $t("ref") }}.</th>
                    <th>{{ $t("nombre") }}</th>
                    <th>{{ $t("uds") }}.</th>
                    <th>{{ $t("partes") }}</th>
                    <th>{{ $t("precioSinIVA") }} / u</th>
                    <th>{{ $t("IVA") }}</th>
                    <th>{{ $t("precio") }} / u</th>
                    <th>{{ $t("total") }}</th>
                    <th>{{ $t("porcentajeDto") }}</th>
                    <th>{{ $t("importe") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="sub in inventario.subproducts">
                    <td>{{ sub.cod_ean }}<br /></td>
                    <td>{{ sub.nameSubproduct }}</td>
                    <td>{{ sub.ud }}</td>

                    <td v-if="sub.escandallo > 1">{{ sub.partes }}</td>
                    <td v-else>-</td>
                    <td>
                      {{ (sub.price / (1 + sub.iva / 100)) | currencyGastos }}
                    </td>
                    <td>{{ sub.iva }}</td>
                    <td style="white-space: nowrap">
                      {{ sub.price | currencyGastos }}
                    </td>
                    <td style="white-space: nowrap" v-if="sub.ivaIncluded">
                      {{ (sub.price * (parseFloat(sub.ud || 0) + parseFloat(sub.partes || 0) / parseFloat(sub.escandallo || 1))) | currencyGastos }}
                    </td>
                    <td style="white-space: nowrap" v-else>
                      {{ sub.total | parseBase(sub.iva) | currencyGastos }}
                    </td>
                    <td>{{ sub.dto }}%</td>
                    
                    <td style="white-space: nowrap" v-if="sub.ivaIncluded">
                      {{ ((sub.price * (parseFloat(sub.ud || 0) + parseFloat(sub.partes || 0) / parseFloat(sub.escandallo || 1)))) * (1 - sub.dto / 100) | currencyGastos }}
                    </td>
                    <td style="white-space: nowrap" v-else>
                      {{ (sub.price / (1 + sub.iva / 100)) * (parseFloat(sub.ud || 0) + parseFloat(sub.partes || 0) / parseFloat(sub.escandallo || 1)) * (1 - sub.dto / 100) | currencyGastos }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="alert alert-danger" role="alert">
              {{ $t("estaEntradaNoContieneNingunSubproducto") }}
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button @click="cerrarModal()" class="btn btn-danger">
              <i class="fas fa-window-close"></i>
              {{ $t("cerrar") }}
            </button>
          </div>
        </div>
      </div>
    </modal>

    <modal name="modal-seleccionar-forma-pago" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true">
      <div class="modal-header">
        <h4 style="margin: 0px; text-align: center">
          {{ $t("seleccioneUnaFormaDePagoParaElGasto") }}
        </h4>
      </div>
      <div class="modal-body">
        <el-select v-model="formaDePagoDeConversion" :placeholder="$t('seleccioneUnaFormaDePago')"
          class="col-md-12 select-default" filterable>
          <el-option v-for="formaDePago in optionsFormaPago" :key="formaDePago.value" :label="formaDePago.label"
            :value="formaDePago.value">
          </el-option>
        </el-select>
      </div>
      <div class="modal-footer">
        <div align="right" class="col-12">
          <button @click="cerrarModal()" class="btn btn-danger">
            <i class="fas fa-window-close"></i>
            {{ $t("cerrar") }}
          </button>
          <button @click="(fromFormaPago = true), openModalConvertirAlbaran()" class="btn btn-primary">
            <i class="fas fa-check"></i>
            {{ $t("aceptar") }}
          </button>
        </div>
      </div>
    </modal>

    <modal name="modal-convertir-albaran" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true">
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("convertirAlbaranEnFactura") }}</h4>
        </div>
        <div class="modal-body">
          <div>
            <div class="form-group">
              <label><strong>{{ $t("refFactura") }}
                  <span style="color: red">*</span></strong></label>
              <input v-model="refFactura" class="form-control" placeholder="Introduzca la ref. de la nueva factura" />
              <label><strong>Fecha de factura <span style="color: red">*</span></strong></label>

              <el-date-picker v-model="fechaFactura" type="date" format="dd-MM-yyyy" prefix-icon="fas fa-calendar-alt"
                clear-icon="fas fa-times-circle" placeholder="Introduzca la fecha de esta factura"></el-date-picker>
              <!-- <el-date-picker
                v-model="horaFactura"
                type="time"
                format="dd-MM-yyyy"
                prefix-icon="fas fa-calendar-alt"
                clear-icon="fas fa-times-circle"
                :start-placeholder="$t('Introduzca la fecha de esta factura')"
                class="form-control"
                :end-placeholder="$t('Introduzca la fecha de esta factura')"
              ></el-date-picker> -->
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button @click="cerrarModal()" class="btn btn-danger">
              <i class="fas fa-window-close"></i>
              {{ $t("cerrar") }}
            </button>
            <button @click="convertirAlbaran()" class="btn btn-primary">
              <i class="fas fa-random"></i>
              {{ $t("convertir") }}
            </button>
          </div>
        </div>
      </div>
    </modal>

    <modal name="modal-albaranes-de-factura" :width="900" :adaptive="true" :scrollable="true" height="auto"
      :clickToClose="true">
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("albaranesDeLaFactura") }}</h4>
        </div>
        <div class="modal-body">
          <div>
            <table class="table table-bordered table-striped">
              <thead class="thead-dark">
                <tr>
                  <th>
                    {{ $t("fecha") }}
                  </th>

                  <th>
                    {{ $t("base") }}
                  </th>
                  <th>
                    {{ $t("importe") }}
                  </th>
                  <th>
                    {{ $t("referencia") }}
                  </th>

                  <th>
                    {{ $t("formaDePago") }}
                  </th>

                  <th>{{ $t("acciones") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="obj in listAlbaranesDeFactura">
                  <td style="width: 10%">{{ obj.date | parseDateMin }}</td>
                  <td align="right" style="width: 10%">
                    {{ obj.base | currency }}
                  </td>
                  <td align="right" style="width: 10%">
                    {{ obj.total | currency }}
                  </td>
                  <td>{{ obj.ref_alb }}</td>
                  <td>
                    <span v-if="obj.formaPago === '0'">{{
                      $t("tranferencia")
                    }}</span>
                    <span v-else-if="obj.formaPago === '1'">{{
                      $t("domiciliacion")
                    }}</span>
                    <span v-else-if="obj.formaPago === '3'">{{
                      $t("tarjeta")
                    }}</span>
                    <span v-else>{{ $t("efectivo") }}</span>
                  </td>
                  <td class="text-center">
                    <span v-tooltip.top-center="$t('verDetalles')" @click="rutas(1, obj)">
                      <i class="far fa-eye"></i></span>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="table-success">
                  <td>
                    <strong>{{ $t("total") }}</strong>
                  </td>

                  <td class="text-right">
                    <strong>{{ getTotalAlbaranBase | currency }}</strong>
                  </td>
                  <td class="text-right">
                    <strong>{{ getTotalAlbaranPrecio | currency }}</strong>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button @click="cerrarModal()" class="btn btn-danger">
              <i class="fas fa-window-close"></i>
              {{ $t("volver") }}
            </button>
          </div>
        </div>
      </div>
    </modal>
    <!-- LOLO -->
    <modal name="modal-conta" :width="400" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true">
      <div class="modal-header">
        <h4 style="margin: 0px">{{ $t("exportarContabilidad") }}</h4>
      </div>
      <div class="modal-body">
        <div class="d-flex">
          <div class="col-6">
            <label for="idStart"><strong>Primer id</strong></label>
            <div class="form-group">
              <vue-numeric type="text" class="form-control" currency-symbol-position="suffix" separator="."
                @keydown.native="$methods.evitarComasDecimales" id="idStart" v-model="idStart"></vue-numeric>
            </div>
          </div>
          <div class="col-6">
            <label for="idEnd"><strong>Último id</strong></label>
            <div class="form-group">
              <vue-numeric id="idEnd" v-model="idEnd" type="text" class="form-control" currency-symbol-position="suffix"
                separator="." @keydown.native="$methods.evitarComasDecimales"></vue-numeric>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div align="right" class="col-12">
          <button @click="closeContModal()" class="btn btn-danger">
            <i class="fas fa-window-close"></i>
            {{ $t("volver") }}
          </button>
          <button @click="exportConta()" class="btn btn-primary">
            <i class="fa fa-check"></i>
            {{ $t("exportar") }}
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
//import Chart from '../../../../node_modules/chart.js/src/chart';
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Radio,
  CheckboxGroup,
  Checkbox,
} from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
import { Loading } from "element-ui";
import { ifft } from "mathjs";
import { mapState } from "vuex";
import download from "downloadjs";

export default {
  mounted() {
    this.$nextTick(this.syncTableScrollWidth);
  },
  updated() {
    this.$nextTick(this.syncTableScrollWidth);
  },
  created() {
    if (this.useGlobalLoading) {
      this.loadingGeneral = Loading.service({ text: this.$t("cargandoGastos") });
    }
    this.$store.dispatch("setNameRoute", this.$i18n.t("gestionDeGastos"));
    this.listProveedores = [{ name: this.$t("todos"), id: 0 }];
    this.getBusiness();

    if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
      this.datefrom = this.$store.getters.dateFrom;
      this.dateto = this.$store.getters.dateTo;
    }
  },
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [Radio.name]: Radio,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
  },
  data() {
    return {
      allowedSet: new Set([
        1234, 1373, 1435, 1439, 1452, 1974, 1981, 2041, 2463,
        3224, 3337, 4256, 4549, 5153, 5831, 6050, 6439
      ]),
      loading: false,
      loadingGeneral: null,
      datefrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      ).toISOString(),
      dateto: new Date().toISOString(),
      listBusinesses: [],
      idBusiness: null,
      value4: [
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        new Date(),
      ],
      gastosConIncremento: [],
      list: [],
      autoFetchOnFilterChange: false, // <-- CAMBIAR SI SE QUIERA AUTO FECTH DE NUEVO
      searchPerformed: false,
      loadingResults: false,
      mode: 1,
      procedencia: 2,
      $Chart: null,
      objectChart: null,
      contador: 0,
      inventario: {
        subproducts: [],
        ivaIncluded: 0,
      },
      idSupplier: 0,
      listProveedores: [],
      listSubproducts: [],
      tipo: 0,
      objGasto: 0,
      contabilizado: -1,
      formaPago: -1,
      identificadorContable: false,
      idStart: 0,
      idEnd: 0,
      currentRequestId: 0, // PARA IDENTIFICAR CONSULTAS ANTIGUAS Y QUE NO SE CRUCEN DATOS U OCURRAN COSAS TRAMBOLICAS
      loadingBusinessId: null, // PARA SABER QUE NEGOCIO ESTA SIENDO CONSULTADO
      procesando: {}, // { [idHeader]: true } MIENTRAS UN GASTO SE ESTA VERIFICANDO O ELIMINANDO, PARA EVITAR DOBLES CLICS
      verificandoTodos: false, // MIENTRAS SE VERIFICAN TODOS LOS GASTOS DE GOLPE
      //ORDENAR
      ordenarFecha: 0,
      ordenarProveedor: 0,
      ordenarBase: 0,
      ordenarImporteIVA: 0,
      ordenarImporte: 0,
      ordenarReferencia: 0,
      ordenarTipo: 0,
      ordenarProcedencia: 0,
      ordenarFormaDePago: 0,
      ordenarEntrAlmac: 0,
      ordenarContab: 0,
      ordenarNombreTpv: 0,
      ordenarNombreApellido: 0,
      ordenarNombreOperario: 0,
      ordenarId: 0,
      ordenarPago: 0,
      ordenarVencimiento: 0,
      ordenarBaseSinDto: 0,
      ordenarImporteTotalSinDto: 0,

      //CONVERIR ALBARAN
      listConvertir: [],
      idSupplierConvertir: 0,

      listFacturas: [],
      idSupplierConvert: [],
      query: "",
      listFacturasIdes: [],
      refFactura: "",
      fechaFactura: "",
      horaFactura: "",

      listAlbaranesDeFactura: [],
      respuesta: true,
      convertirAlbaranes: false,

      filtrarPorFecha: true,
      listIdentificadorContable: [],

      formaDePagoDeConversion: null,
      fromFormaPago: false,
      optionsFormaPago: [
        {
          value: 0,
          label: "Transferencia",
        },
        {
          value: 1,
          label: "Domiciliación",
        },
        {
          value: 2,
          label: "Efectivo",
        },
        {
          value: 3,
          label: "Tarjeta",
        },
      ],
      tieneSage: false,
      importeTotal: 0,
      fechaVencimiento: "",
      verificado: -1,
      pendientePago: -1,
      xlist: [],
      useGlobalLoading: false, // USAR EL LOADING SERVICE O NO
      globalLoadingInstance: null,
    };
  },
  computed: {
    ...mapState(["permiso"]),
    timezoneId() {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    },
    fechahorafactura() {
      return new Date(this.fechaFactura).getTime() / 1000; // + " " + this.horaFactura
    },
    urlExportPDF() {
      /*  return "../api/public/index.php/suppliers/exportGastosSupplier/PDF?idBusiness=" + this.idBusiness   + "&procedencia=" + this.procedencia + "&idSupplier=" + this.idSupplier + "&datefrom=" + moment(this.datefrom).unix() + "&dateto=" + moment(this.dateto).unix() + "&jwt=" + this.$store.getters.jwt
       */
      return (
        this.$store.getters.apiUrl +
        "/gastos/exportGastos/PDF?idBusiness=" +
        this.idBusiness +
        "&procedencia=" +
        this.procedencia +
        "&mode=" +
        this.mode +
        "&idSupplier=" +
        this.idSupplier +
        "&filtrarPorFecha=" +
        this.filtrarPorFecha +
        "&datefrom=" +
        moment(this.datefrom).startOf("day").unix() +
        "&dateto=" +
        moment(this.dateto).endOf("day").unix() +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportExcel() {
      /*  return "../api/public/index.php/suppliers/exportGastosSupplier/Excel?idBusiness=" + this.idBusiness + "&procedencia=" + this.procedencia + "&idSupplier=" + this.idSupplier + "&datefrom=" + moment(this.datefrom).unix() + "&dateto=" + moment(this.dateto).unix() + "&jwt=" + this.$store.getters.jwt
       */
      return (
        this.$store.getters.apiUrl +
        "/gastos/exportGastos/Excel?idBusiness=" +
        this.idBusiness +
        "&procedencia=" +
        this.procedencia +
        "&mode=" +
        this.mode +
        "&idSupplier=" +
        this.idSupplier +
        "&filtrarPorFecha=" +
        this.filtrarPorFecha +
        "&datefrom=" +
        moment(this.datefrom).startOf("day").unix() +
        "&dateto=" +
        moment(this.dateto).endOf("day").unix() +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },

    getBaseTotal() {
      this.d.subproduct.forEach(function (d) {
        total += parseFloat(d.baseImpDto);
      });
      return total;
    },
    getTotalAlbaranPrecio() {
      let total = 0;
      this.listAlbaranesDeFactura.forEach(function (d) {
        total += parseFloat(d.total);
      });
      return total;
    },
    getTotalAlbaranBase() {
      let total = 0;
      this.listAlbaranesDeFactura.forEach(function (d) {
        total += parseFloat(d.base);
      });
      return total;
    },

    getTotalPrecio() {
      let total = 0;
      this.list.forEach(function (d) {
        total += d.price;
      });
      return total;
    },
    getTotalBase() {
      let total = 0;
      this.list.forEach(function (d) {
        total += d.base;
      });
      return total;
    },
    getTotalBaseSinDto() {
      let total = 0;
      this.list.forEach(function (d) {
        total += d.baseSinDto || 0;
      });
      return total;
    },
    getTotalImporteTotalSinDto() {
      let total = 0;
      this.list.forEach(function (d) {
        total += d.importeTotalSinDto || 0;
      });
      return total;
    },
  },
  methods: {
    syncTableScrollWidth() {
      const table = this.$refs.tableResponsive;
      const topInner = this.$refs.tableScrollTopInner;
      if (table && topInner) {
        topInner.style.width = table.scrollWidth + "px";
      }
    },
    onTopScroll() {
      if (this.$refs.tableResponsive && this.$refs.tableScrollTop) {
        this.$refs.tableResponsive.scrollLeft = this.$refs.tableScrollTop.scrollLeft;
      }
    },
    onBottomScroll() {
      if (this.$refs.tableResponsive && this.$refs.tableScrollTop) {
        this.$refs.tableScrollTop.scrollLeft = this.$refs.tableResponsive.scrollLeft;
      }
    },
    accion(x) {
      if (this.listConvertir.length > 0) {
        this.idSupplierConvertir = x;
      } else {
        this.idSupplierConvertir = 0;
      }
    },

    seleccionarTodosAlbaranes() {
      if (this.idSupplierConvertir != 0) {
        this.listConvertir = [];

        this.list.forEach((gasto) => {
          // Los "gastos sencillos" sin gastocab (idCab === 0) no tienen verificado ya que no tienen idCab
          // El backend los crea y verifica al vuelo al convertir.
          if (gasto.type === "A" && (gasto.idCab === 0 || gasto.verificado === 1)) {
            if (gasto.supplierId == this.idSupplierConvertir) {
              this.listConvertir.push(gasto.idHeader);
            }
          }
        });
      }
    },

    cambiarNegocio() {
      this.getProveedores();
      this.idSupplier = 0;
      this.listProveedores = [{ name: this.$t("todos"), id: 0 }];
      this.idSupplierConvert = 0;
      this.listFacturasIdes = [];
      this.query = "";
      this.list = [];
      this.searchPerformed = false;
      this.loading = false;
    },

    handleFilterChange() {
      if (this.autoFetchOnFilterChange) {
        this.getGastosNegocio();
      }
    },

    getConfigIdentificador() {
      let vm = this;

      let configIdentificador = "100";

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idBusiness: this.idBusiness,
          numConfig: configIdentificador,
        },

        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      this.axios
        .get(
          this.$store.getters.apiUrl + "general/checkConfigByBusiness",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.identificadorContable = response.data.result;

            vm.getTieneSage();
          } else {
            swal({
              title: vm.$t("atencion"),
              text: vm.$t("error"),
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getTieneSage() {
      if (this.idBusiness.length > 0) {
        var config = {
          params: {
            idTpv: this.idTpv,
            numConfig: "36",
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let vm = this;
        this.axios
          .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
          .then(function (response) {
            if (response.data.response == true) {
              vm.respuesta = true;
              vm.tieneSage = true;
            }

            vm.loading = false;
            if (vm.loadingGeneral) vm.loadingGeneral.close();
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },

    searchAlbaranes() {
      if (this.query !== "") {
        const controller = "  Albaranes/" + this.query;
        var config = {
          params: {
            idBusiness: this.idBusiness,
            jwt: this.$store.getters.jwt,
            idSupplier: this.idSupplierConvert,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let vm = this;
        this.axios
          .get(this.$store.getters.apiUrl + "gastos/" + controller, config)
          .then(function (response) {
            if (response.data.response) {
              vm.listFacturas = response.data.result;
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },

    convertirAlbaran() {
      if (this.refFactura !== "") {
        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        // Construir array de objetos con idHeader e idCab
        let listFacturasIdes = [];
        this.listConvertir.forEach((idHeaderSeleccionado) => {
          this.list.forEach((gasto) => {
            if (idHeaderSeleccionado == gasto.idHeader) {
              listFacturasIdes.push({
                idHeader: gasto.idHeader,
                idCab: gasto.idCab
              });
            }
          });
        });

        var params = {
          listFacturasIdes: listFacturasIdes,
          idBusiness: this.idBusiness,
          refFactura: this.refFactura,
          fechaFactura: this.fechahorafactura,
          idSupplier: this.idSupplierConvertir,
          formaDePago: this.formaDePagoDeConversion,
          jwt: this.$store.getters.jwt,
        };

        let vm = this;
        let controller = "convertirAlbaran";
        this.axios
          .post(
            this.$store.getters.apiUrl + "gastos/" + controller,
            params,
            config
          )
          .then(function (response) {
            if (response.data.response) {
              let notify = vm.$t("finalizada");
              vm.$notify({
                message:
                  vm.$t("conversion") +
                  " " +
                  notify +
                  " " +
                  vm.$t("correctamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });

              vm.$modal.hide("modal-convertir-albaran");
              vm.getGastosNegocio();
              vm.convertirAlbaranes = false;
              vm.idSupplierConvertir = 0;
              vm.listConvertir = [];
              vm.idSupplierConvert = 0;
              vm.listFacturasIdes = [];
              vm.query = "";
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
            vm.inProgress = false;
          });
      } else {
        swal({
          title: this.$t("atencion"),
          text: this.$t("relleneLosCamposObligatorios"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      }
    },

    getAlbaranesByFacturas(idCab) {
      const controller = "getAlbaranesByFacturas";
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          idCab: idCab,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      this.$store.dispatch("setIdBusiness", this.idBusiness);

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "gastos/" + controller, config)
        .then(function (response) {
          if (response.data.response) {
            vm.listAlbaranesDeFactura = response.data.result;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    openModalConvertirAlbaran() {

      this.$modal.hide("modal-seleccionar-forma-pago");

      if (this.formaDePagoDeConversion != null && this.fromFormaPago) {
        this.$modal.show("modal-convertir-albaran");
        this.fromFormaPago = false;
      } else {
        this.fromFormaPago = false;

        let formasDePago = [];

        this.listConvertir.forEach((idHeaderSeleccionado) => {
          this.list.forEach((gasto) => {
            if (idHeaderSeleccionado == gasto.idHeader) {
              if (!formasDePago.includes(gasto.formaPago)) {
                formasDePago.push(gasto.formaPago);
              }
            }
          });
        });

        if (formasDePago.length == 1) {
          this.formaDePagoDeConversion = formasDePago[0];
          this.$modal.show("modal-convertir-albaran");
        } else {
          this.$modal.show("modal-seleccionar-forma-pago");
        }
      }
    },

    verificarTodo() {
      if (this.verificandoTodos || this.listBusinesses.length === 0) {
        return;
      }

      let vm = this;
      this.gastosConIncremento = [];

      if (Array.isArray(vm.list) && vm.list.length > 0) {

        let gastosNoVerificables = [];

        vm.list.forEach(gasto => {
          if (Boolean(gasto.verificado)) {
            return;
          }

          if (Array.isArray(gasto.listaSubproductos) && gasto.listaSubproductos.length > 0) {
            let subproductosIncrementados = gasto.listaSubproductos.filter(subproduct => {
              return subproduct && subproduct.estaIncrementado === true;
            });

            if (subproductosIncrementados.length > 0) {

              this.gastosConIncremento.push(gasto);

              gasto.verificable = false;
            }
          }
        });

        if (this.gastosConIncremento.length > 0) {
          const porcentajeAcordado = this.gastosConIncremento[0].porcentajeAcordado || "No definido";

          let mensajeError = `<div style="text-align: left;">${vm.$t("mensajeErrorVerificarTodo")} (${porcentajeAcordado}%).<br><br>¿Deseas verificar todos los gastos?</div><br>`;

          this.gastosConIncremento.forEach(gasto => {
            const timestamp = gasto.date;
            const fecha = new Date(timestamp * 1000);
            const dia = fecha.getDate().toString().padStart(2, '0');
            const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
            const anio = fecha.getFullYear(); // Año
            const fechaFormateada = `${dia}/${mes}/${anio}`;
            mensajeError += `<div style="text-align: left;">·REF: ${gasto.ref} - ${fechaFormateada}<br></div>`;
          });

          swal({
            title: vm.$t("atencion"),
            html: mensajeError,
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonClass: "btn btn-success btn-fill",
            cancelButtonClass: "btn btn-danger btn-fill",
            confirmButtonText: this.$t("siVerificarGastos"),
            cancelButtonText: this.$t("cancelar"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "warning",
          }).then((result) => {
            if (result.value) {
              this.verificarTodosLosGastos();
            }
          });

          return;
        } else {

          swal({
            title: this.$t("estaSeguroDeVerificarTodosLosGastos"),
            text: this.$t("estaOperacionNoSePuedeDeshacer"),
            type: "info",
            showCancelButton: true,
            confirmButtonClass: "btn btn-success btn-fill",
            cancelButtonClass: "btn btn-danger btn-fill",
            confirmButtonText: this.$t("siVerificarGastos"),
            cancelButtonText: this.$t("cancelar"),
            buttonsStyling: true,
          }).then((result) => {
            if (result.value) {
              this.verificarTodosLosGastos();
            }
          });
        }
      }
    },





    openModalAlbaranesFactura(idCab) {
      this.getAlbaranesByFacturas(idCab);

      this.$modal.show("modal-albaranes-de-factura");
    },

    sortedArrayASC: function (nameAtributo) {
      switch (nameAtributo) {
        case 1:
          this.ordenarFecha = 1;

          function compareFecha(a, b) {
            if (a.date.toUpperCase() < b.date.toUpperCase()) return -1;
            if (a.date.toUpperCase() > b.date.toUpperCase()) return 1;
            return 0;
          }

          return this.list.sort(compareFecha);

        case 2:
          this.ordenarProveedor = 1;

          function compareProveedor(a, b) {
            if (a.supplierName < b.supplierName) return -1;
            if (a.supplierName > b.supplierName) return 1;
            return 0;
          }

          return this.list.sort(compareProveedor);

        case 3:
          this.ordenarBase = 1;

          function compareBase(a, b) {
            if (a.base < b.base) return -1;
            if (a.base > b.base) return 1;
            return 0;
          }

          return this.list.sort(compareBase);

        case 4:
          this.ordenarImporte = 1;

          function compareImporte(a, b) {
            if (a.price < b.price) return -1;
            if (a.price > b.price) return 1;
            return 0;
          }

          return this.list.sort(compareImporte);

        case 5:
          this.ordenarReferencia = 1;

          function compareReferencia(a, b) {
            if (a.ref < b.ref) return -1;
            if (a.ref > b.ref) return 1;
            return 0;
          }

          return this.list.sort(compareReferencia);

        case 6:
          this.ordenarTipo = 1;

          function compareTipo(a, b) {
            if (a.type < b.type) return -1;
            if (a.type > b.type) return 1;
            return 0;
          }

          return this.list.sort(compareTipo);

        case 7:
          this.ordenarProcedencia = 1;

          function compareProcedencia(a, b) {
            if (a.fromCash < b.fromCash) return -1;
            if (a.fromCash > b.fromCash) return 1;
            return 0;
          }

          return this.list.sort(compareProcedencia);

        case 8:
          this.ordenarFormaDePago = 1;

          function compareFormaPago(a, b) {
            if (a.formaPago < b.formaPago) return -1;
            if (a.formaPago > b.formaPago) return 1;
            return 0;
          }

          return this.list.sort(compareFormaPago);

        case 9:
          this.ordenarContab = 1;

          function compareContabilizado(a, b) {
            if (a.contabilizado < b.contabilizado) return -1;
            if (a.contabilizado > b.contabilizado) return 1;
            return 0;
          }

          return this.list.sort(compareContabilizado);

        case 10:
          this.ordenarNombreTpv = 1;

          function compareNombreTpv(a, b) {
            if (a.nombreTpv < b.nombreTpv) return -1;
            if (a.nombreTpv > b.nombreTpv) return 1;
            return 0;
          }

          return this.list.sort(compareNombreTpv);

        case 11:
          this.ordenarNombreOperario = 1;

          function compareOperario(a, b) {
            if (a.nombreOperario < b.nombreOperario) return -1;
            if (a.nombreOperario > b.nombreOperario) return 1;
            return 0;
          }

          return this.list.sort(compareOperario);
        case 12:
          this.ordenarImporteIVA = 1;
          //TODO
          function compareImporteIVA(a, b) {
            if (a.importeIVA < b.importeIVA) return -1;
            if (a.importeIVA > b.importeIVA) return 1;
            return 0;
          }

          return this.list.sort(compareImporteIVA);

        case 13:
          this.ordenarId = 1;
          function compareIdentificadorContable(a, b) {
            if (parseInt(a.identificador) < parseInt(b.identificador))
              return -1;
            if (parseInt(a.identificador) > parseInt(b.identificador)) return 1;
            return 0;
          }

          return this.list.sort(compareIdentificadorContable);

        case 14:
          this.ordenarPago = 1;

          function comparePendientePago(a, b) {
            if (a.pendientePago === b.pendientePago) {
              return 0;
            }
            if (a.pendientePago) {
              return 1;
            }
            return -1;
          }

          return this.list.sort(comparePendientePago);
        case 15:
          this.ordenarVencimiento = 1;

          function compareVencimiento(a, b) {
            if (
              a.dateVencimiento.toUpperCase() < b.dateVencimiento.toUpperCase()
            )
              return -1;
            if (
              a.dateVencimiento.toUpperCase() > b.dateVencimiento.toUpperCase()
            )
              return 1;
            return 0;
          }

          return this.list.sort(compareVencimiento);

        case 16:
          this.ordenarEntrAlmac = 1;

          function compareAlmacen(a, b) {
            if (a.generateWarehouse < b.generateWarehouse) return -1;
            if (a.generateWarehouse > b.generateWarehouse) return 1;
            return 0;
          }

          return this.list.sort(compareAlmacen);

        case 17:
          this.ordenarBaseSinDto = 1;

          function compareBaseSinDto(a, b) {
            if ((a.baseSinDto || 0) < (b.baseSinDto || 0)) return -1;
            if ((a.baseSinDto || 0) > (b.baseSinDto || 0)) return 1;
            return 0;
          }

          return this.list.sort(compareBaseSinDto);
        case 18:
          this.ordenarImporteTotalSinDto = 1;

          function compareImporteTotalSinDto(a, b) {
            if ((a.importeTotalSinDto || 0) < (b.importeTotalSinDto || 0)) return -1;
            if ((a.importeTotalSinDto || 0) > (b.importeTotalSinDto || 0)) return 1;
            return 0;
          }

          return this.list.sort(compareImporteTotalSinDto);
      }
    },
    sortedArrayDESC: function (nameAtributo) {
      switch (nameAtributo) {
        case 1:
          this.ordenarFecha = 0;

          function compareFecha(a, b) {
            if (a.date.toUpperCase() > b.date.toUpperCase()) return -1;
            if (a.date.toUpperCase() < b.date.toUpperCase()) return 1;
            return 0;
          }

          return this.list.sort(compareFecha);

        case 2:
          this.ordenarProveedor = 0;

          function compareProveedor(a, b) {
            if (a.supplierName > b.supplierName) return -1;
            if (a.supplierName < b.supplierName) return 1;
            return 0;
          }

          return this.list.sort(compareProveedor);

        case 3:
          this.ordenarBase = 0;

          function compareBase(a, b) {
            if (a.base > b.base) return -1;
            if (a.base < b.base) return 1;
            return 0;
          }

          return this.list.sort(compareBase);

        case 4:
          this.ordenarImporte = 0;

          function compareImporte(a, b) {
            if (a.price > b.price) return -1;
            if (a.price < b.price) return 1;
            return 0;
          }

          return this.list.sort(compareImporte);

        case 5:
          this.ordenarImporte = 0;

          function compareReferencia(a, b) {
            if (a.ref > b.ref) return -1;
            if (a.ref < b.ref) return 1;
            return 0;
          }

          return this.list.sort(compareReferencia);

        case 6:
          this.ordenarTipo = 0;

          function compareTipo(a, b) {
            if (a.type > b.type) return -1;
            if (a.type < b.type) return 1;
            return 0;
          }

          return this.list.sort(compareTipo);

        case 7:
          this.ordenarProcedencia = 0;

          function compareProcedencia(a, b) {
            if (a.fromCash > b.fromCash) return -1;
            if (a.fromCash < b.fromCash) return 1;
            return 0;
          }

          return this.list.sort(compareProcedencia);

        case 8:
          this.ordenarFormaDePago = 0;

          function compareFormaPago(a, b) {
            if (a.formaPago > b.formaPago) return -1;
            if (a.formaPago < b.formaPago) return 1;
            return 0;
          }

          return this.list.sort(compareFormaPago);

        case 9:
          this.ordenarContab = 0;

          function compareContabilizado(a, b) {
            if (a.contabilizado > b.contabilizado) return -1;
            if (a.contabilizado < b.contabilizado) return 1;
            return 0;
          }

          return this.list.sort(compareContabilizado);

        case 10:
          this.ordenarNombreTpv = 0;

          function compareNombreTpv(a, b) {
            if (a.nombreTpv > b.nombreTpv) return -1;
            if (a.nombreTpv < b.nombreTpv) return 1;
            return 0;
          }

          return this.list.sort(compareNombreTpv);

        case 11:
          this.ordenarNombreOperario = 0;

          function compareOperario(a, b) {
            if (a.nombreOperario > b.nombreOperario) return -1;
            if (a.nombreOperario < b.nombreOperario) return 1;
            return 0;
          }

          return this.list.sort(compareOperario);
        case 12:
          this.ordenarImporteIVA = 0;

          function compareImporteIVA(a, b) {
            if (a.importeIVA > b.importeIVA) return -1;
            if (a.importeIVA < b.importeIVA) return 1;
            return 1;
          }

          return this.list.sort(compareImporteIVA);

        case 13:
          this.ordenarId = 0;
          function compareIdentificadorContable(a, b) {
            if (parseInt(a.identificador) > parseInt(b.identificador))
              return -1;
            if (parseInt(a.identificador) < parseInt(b.identificador)) return 1;
            return 1;
          }

          return this.list.sort(compareIdentificadorContable);

        case 14:
          this.ordenarPago = 0;

          function comparePendientePago(a, b) {
            if (a.pendientePago === b.pendientePago) {
              return 0;
            }
            if (a.pendientePago) {
              return -1;
            }
            return 1;
          }

          return this.list.sort(comparePendientePago);

        case 15:
          this.ordenarVencimiento = 0;

          function compareVencimiento(a, b) {
            if (
              a.dateVencimiento.toUpperCase() > b.dateVencimiento.toUpperCase()
            )
              return -1;
            if (
              a.dateVencimiento.toUpperCase() < b.dateVencimiento.toUpperCase()
            )
              return 1;
            return 0;
          }

          return this.list.sort(compareVencimiento);

        case 16:
          this.ordenarEntrAlmac = 0;

          function compareAlmacen(a, b) {
            if (a.generateWarehouse > b.generateWarehouse) return -1;
            if (a.generateWarehouse < b.generateWarehouse) return 1;
            return 0;
          }

          return this.list.sort(compareAlmacen);

        case 17:
          this.ordenarBaseSinDto = 0;

          function compareBaseSinDto(a, b) {
            if ((a.baseSinDto || 0) > (b.baseSinDto || 0)) return -1;
            if ((a.baseSinDto || 0) < (b.baseSinDto || 0)) return 1;
            return 0;
          }

          return this.list.sort(compareBaseSinDto);
        case 18:
          this.ordenarImporteTotalSinDto = 0;

          function compareImporteTotalSinDto(a, b) {
            if ((a.importeTotalSinDto || 0) > (b.importeTotalSinDto || 0)) return -1;
            if ((a.importeTotalSinDto || 0) < (b.importeTotalSinDto || 0)) return 1;
            return 0;
          }

          return this.list.sort(compareImporteTotalSinDto);
      }
    },

    rutas(ruta, obj) {
      if (ruta === 1) {
        this.$router.push({
          name: "gestion-gasto",
          params: {
            idBusiness: this.idBusiness,
            idGasto: obj.idHeader,
            vista: 1,
          },
        });
      } else if (ruta === 2) {
        this.$router.push({
          name: "gestion-gasto",
          params: { idBusiness: this.idBusiness, idGasto: obj.idHeader },
        });
      } else if (ruta === 3) {
        this.$router.push({
          name: "gestion-gasto",
          params: {
            idBusiness: this.idBusiness,
            idGasto: obj.idHeader,
            vista: 2,
          },
        });
      }
    },

    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function (response) {
          vm.listBusinesses = response.data.result;

          if (!response.data.result || response.data.result.length === 0) {
            if (vm.loadingGeneral) vm.loadingGeneral.close();
            swal({
              title: vm.$t("ups"),
              text: vm.$t("noTienesNingunNegocioAsignado"),
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
            return;
          }

          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }

          vm.getProveedores();
        })
        .catch(function (error) {
          console.log(error);
          if (vm.loadingGeneral) vm.loadingGeneral.close();
        });
    },

    getProveedores() {
      const controller = "getSuppliersByBusiness";
      var config = {
        params: {
          pag: 0,
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      this.$store.dispatch("setIdBusiness", this.idBusiness);

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "suppliers/" + controller, config)
        .then(function (response) {
          if (response.data.response) {
            vm.listProveedores = [{ name: vm.$t("todos"), id: 0 }];
            
            // Agregar los proveedores
            for (let i = 0; i < response.data.result.suppliers.length; i++) {
              let proveedorname = {
                name: response.data.result.suppliers[i].name,
                id: response.data.result.suppliers[i].id,
              };
              vm.listProveedores.push(proveedorname);
            }

            // vm.getGastosNegocio();
            if (vm.loadingGeneral) vm.loadingGeneral.close();
          } else {
            vm.respuesta = false;
            if (vm.loadingGeneral) vm.loadingGeneral.close();
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          if (vm.loadingGeneral) vm.loadingGeneral.close();
        });
    },

    getGastosNegocio() {
      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: this.$t("ups"),
          text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        let secondsDesde = moment(this.datefrom).unix();
        let secondsHasta = moment(this.dateto).unix();

        if (secondsHasta < secondsDesde) {
          swal({
            title: this.$t("ups"),
            text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        } else {
          this.currentRequestId++;
          const requestId = this.currentRequestId;
          const requestBusinessId = this.idBusiness;
          this.loadingBusinessId = this.idBusiness; // RASTREAR QUE NEGOCIO ESTA CONSULTANDO
          this.searchPerformed = true;
          this.loadingResults = true;
          this.loading = true;
          this.list = [];
          this.$store.dispatch("setDateTo", this.dateto);
          this.$store.dispatch("setDateFrom", this.datefrom);
          
          if (this.useGlobalLoading) {
            this.globalLoadingInstance = Loading.service({ text: this.$t("cargandoGastos") });
          }

          var config = {
            params: {
              idBusiness: this.idBusiness,
              mode: this.mode,
              datefrom: moment(this.datefrom).startOf("day").unix(),
              dateto: moment(this.dateto).endOf("day").unix(),
              procedencia: this.procedencia,
              filtrarPorFecha: this.filtrarPorFecha,
              idSupplier: this.idSupplier,
              jwt: this.$store.getters.jwt,
            },

            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };

          let vm = this;
          this.axios
            .get(this.$store.getters.apiUrl + "gastos/getExpenses", config)
            .then(function (response) {
              // Cerrar loading global si está activo
              if (vm.globalLoadingInstance) {
                vm.globalLoadingInstance.close();
                vm.globalLoadingInstance = null;
              }
              
              // Ignorar respuestas de peticiones antiguas o de negocio diferente
              if (requestId !== vm.currentRequestId || requestBusinessId !== vm.idBusiness) {
                return;
              }
              
              vm.searchPerformed = true;
              vm.loadingResults = false;
              vm.loading = false;
              vm.loadingBusinessId = null; // TERMINAR DE RASTREAR ESTE NEGOCIO

              if (response.data.response) {
                var xlist = [];

                if (vm.contabilizado === -1) {
                  xlist = response.data.result;
                } else {
                  for (let i = 0; i < response.data.result.length; i++) {
                    if (
                      vm.contabilizado === response.data.result[i].contabilizado
                    ) {
                      xlist.push(response.data.result[i]);
                    }
                  }
                }

                var xlistTipo = [];

                if (vm.tipo === 0) {
                  xlistTipo = xlist;
                } else {
                  for (let i = 0; i < xlist.length; i++) {
                    if (vm.tipo === xlist[i].type) {
                      xlistTipo.push(xlist[i]);
                    }
                  }
                }

                var xlistFormaPago = [];
                if (vm.formaPago === -1) {
                  xlistFormaPago = xlistTipo;
                } else {
                  for (let i = 0; i < xlistTipo.length; i++) {
                    if (vm.formaPago === xlistTipo[i].formaPago) {
                      xlistFormaPago.push(xlistTipo[i]);
                    }
                  }
                }

                var xlistPendientePago = [];

                if (vm.pendientePago === -1) {
                  xlistPendientePago = xlistFormaPago;
                } else {
                  for (let i = 0; i < xlistFormaPago.length; i++) {
                    if (vm.pendientePago === xlistFormaPago[i].pendientePago) {
                      xlistPendientePago.push(xlistFormaPago[i]);
                    }
                  }
                }

                if (vm.verificado === -1) {
                  vm.list = xlistPendientePago;
                } else {
                  for (let i = 0; i < xlistPendientePago.length; i++) {
                    if (vm.verificado === xlistPendientePago[i].verificado) {
                      vm.list.push(xlistPendientePago[i]);
                    }
                  }
                }


                vm.getConfigIdentificador();
                vm.respuesta = true;
              } else {
                swal({
                  title: vm.$t("error"),
                  text: response.data.message,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });
                vm.respuesta = false;
                // vm.$router.push({ name: 'informes'});
              }
            })
            .catch(function (error) {
              // Cerrar loading global si está activo
              if (vm.globalLoadingInstance) {
                vm.globalLoadingInstance.close();
                vm.globalLoadingInstance = null;
              }
              
              // Ignorar errores de peticiones antiguas o de negocio diferente
              if (requestId !== vm.currentRequestId || requestBusinessId !== vm.idBusiness) {
                return;
              }
              console.log(error);
              vm.loadingResults = false;
              vm.loading = false;
              vm.loadingBusinessId = null; // TERMINAR DE RASTREAR ESTE NEGOCIO
            });
        }
      }
    },

    modalverificar(obj) {
      if (this.procesando[obj.idHeader]) {
        return;
      }
      this.$set(this.procesando, obj.idHeader, true);

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idHeader: obj.idHeader,  // Aquí asumo que "idHeader" viene de "obj"
          idBusiness: this.idBusiness,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      let controller = "openInventario";

      this.axios
        .get(this.$store.getters.apiUrl + "gastos/" + controller, config)
        .then(function (response) {
          if (response.data.response) {
            if (response.data.result.length > 0) {
              vm.inventario.subproducts = response.data.result;
              vm.inventario.ivaIncluded = response.data.result[0].ivaIncluded;
            } else {
              vm.inventario.subproducts = [];
              vm.inventario.ivaIncluded = 0;
            }
            let subproductosIncrementados = [];

            vm.inventario.subproducts.forEach((subproduct, index, array) => {
              if (subproduct.estaIncrementado === true) {
                let precioInicial = subproduct.precioCompraSinIvaInicial || 0;
                let precioFinal = subproduct.precioCompraSinIva || 0;
                let porcentajeAcordado = subproduct.porcentajeAcordado || "No definido";

                subproductosIncrementados.push({
                  nameSubproduct: subproduct.nameSubproduct,
                  precioInicial: precioInicial.toFixed(2),
                  precioFinal: precioFinal.toFixed(2),
                  porcentajeAcordado: porcentajeAcordado
                });
              }
            });

            if (vm.allowedSet.has(Number(vm.idBusiness)) && subproductosIncrementados.length > 0) {

              let nombresSubproductos = subproductosIncrementados.map((subproducto, index, array) => {
                if (index < array.length - 1) {
                  return `· ${subproducto.nameSubproduct}: de ${subproducto.precioInicial} € a ${subproducto.precioFinal} €,`;
                } else {
                  return `· ${subproducto.nameSubproduct}: de ${subproducto.precioInicial} € a ${subproducto.precioFinal} €.<br><br>¿Desea verificar el gasto?`;
                }
              }).join('<br>');
              let mensajeError = vm.$t("losSubproductosSeHanIncrementado") + ` (${subproductosIncrementados[0].porcentajeAcordado}%).<br><br>`; // Utilizamos el mensaje de traducción
              mensajeError += nombresSubproductos;
              swal({
                title: vm.$t("atencion"),
                position: "left",
                html: `<div style="text-align: left;">${mensajeError}</div>`,
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonClass: "btn btn-success btn-fill",
                cancelButtonClass: "btn btn-danger btn-fill",
                confirmButtonText: vm.$t("siVerficarGasto"),
                cancelButtonText: vm.$t("cancelar"),
                type: "warning",
              }).then((result) => {
                if (result.value) {
                  vm.verificarGasto(obj);
                } else {
                  vm.$delete(vm.procesando, obj.idHeader);
                }
              });
              return;

            }
            swal({
              title: vm.$t("estaSeguroDeVerificarEsteGasto"),
              text: vm.$t("estaOperacionNoSePuedeDeshacer"),
              type: "info",
              showCancelButton: true,
              showCloseButton: true,
              confirmButtonClass: "btn btn-success btn-fill",
              cancelButtonClass: "btn btn-danger btn-fill",
              confirmButtonText: vm.$t("siVerficarGasto"),
              cancelButtonText: vm.$t("cancelar"),
              buttonsStyling: true,
            }).then((result) => {
              if (result.value) {
                vm.verificarGasto(obj);
              } else {
                vm.$delete(vm.procesando, obj.idHeader);
              }
            });

          } else {
            vm.$delete(vm.procesando, obj.idHeader);
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
          vm.$delete(vm.procesando, obj.idHeader);
        });
    },




    modaleliminar(obj) {
      if (this.procesando[obj.idHeader]) {
        return;
      }
      this.$set(this.procesando, obj.idHeader, true);

      let vm = this;
      swal({
        title: this.$t("estasSeguroDeEliminarElGasto"),
        text: this.$t("estaOperacionNoSePuedeDeshacer"),
        type: "info",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: this.$t("siEliminarGasto"),
        cancelButtonText: this.$t("cancelar"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          vm.eliminarGasto(obj);
        } else {
          vm.$delete(vm.procesando, obj.idHeader);
        }
      });
    },

    cumpleFiltroVerificado(item) {
      return this.verificado === -1 || this.verificado === item.verificado;
    },

    quitarDeListaSiNoCumpleFiltro(obj) {
      if (!this.cumpleFiltroVerificado(obj)) {
        this.list = this.list.filter((item) => item !== obj);
      }
    },

    verificarGasto(obj) {


      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        jwt: this.$store.getters.jwt,
        idHeader: obj.idHeader,
        idBusiness: this.idBusiness,
      };

      let vm = this;
      let controller = "verificarExpense";
      this.axios
        .post(
          this.$store.getters.apiUrl + "gastos/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.$notify({
              message: vm.$t("gastoVerificadoCorrectamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            let resultado = response.data.result;
            if (resultado && resultado.expense) {
              Object.assign(obj, resultado.expense);
              vm.quitarDeListaSiNoCumpleFiltro(obj);
            }

            if (resultado && resultado.msg) {
              swal({
                title: vm.$t("atencion"),
                text: resultado.msg,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "info",
              });
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        })
        .finally(function () {
          vm.$delete(vm.procesando, obj.idHeader);
        });
    },

    verificarTodosLosGastos() {
      if (this.verificandoTodos) {
        return;
      }
      this.verificandoTodos = true;

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        jwt: this.$store.getters.jwt,
        idBusiness: this.idBusiness,
      };

      let vm = this;
      let controller = "verificarAllExpenses";
      this.axios
        .post(
          this.$store.getters.apiUrl + "gastos/" + controller,
          params,
          config
        )
        .then(function (response) {
          // El backend puede devolver los gastos verificados hasta el momento
          // aunque el proceso se haya detenido a mitad por un error en otro gasto,
          // así que aplicamos el parcial siempre, éxito o fallo.
          let verificados = response.data.result || [];
          for (let i = 0; i < verificados.length; i++) {
            let expense = verificados[i];
            let obj = vm.list.find((item) => item.idHeader === expense.idHeader);
            if (obj) {
              Object.assign(obj, expense);
            }
          }
          if (verificados.length > 0) {
            vm.list = vm.list.filter((item) => vm.cumpleFiltroVerificado(item));
          }

          if (response.data.response) {
            vm.$notify({
              message: vm.$t("gastosVerificadosCorrectamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        })
        .finally(function () {
          vm.verificandoTodos = false;
        });
    },

    contabilizar(p) {
      if (p.fromCash == 0) {
        if (p.contabilizado == 0) {
          p.contabilizado = 1;
        } else {
          p.contabilizado = 0;
        }
        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };
        var params = {
          jwt: this.$store.getters.jwt,
          idHeader: p.idHeader,
          contabilizado: p.contabilizado,
          idBusiness: this.idBusiness,
        };

        let vm = this;
        let controller = "changeContabilizado";
        this.axios
          .post(
            this.$store.getters.apiUrl + "gastos/" + controller,
            params,
            config
          )
          .then(function (response) {
            if (response.data.response) {
              vm.$notify({
                message: vm.$t("contabilizadoCambiadoCorrectamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
            vm.inProgress = false;
          });
      }
    },

    updateExportadoSage(g) {
      this.textoPregunta =
        g.exportadoSage === 0
          ? this.$t("askUpdateExportadoSageTrue")
          : this.$t("askUpdateExportadoSageFalse");
      swal({
        title: this.$t("titleModificarExportadoSage"),
        text: this.textoPregunta,
        type: "info",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: this.$t("si"),
        cancelButtonText: this.$t("cancelar"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          var config = {
            params: {
              jwt: this.$store.getters.jwt,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };
          var params = {
            jwt: this.$store.getters.jwt,
            idHeader: g.idHeader,
            exportadoSage: g.exportadoSage ? 0 : 1,
            idBusiness: this.idBusiness,
          };

          let vm = this;
          let controller = "updateExportadoSage";
          this.axios
            .post(
              this.$store.getters.apiUrl + "gastos/" + controller,
              params,
              config
            )
            .then(function (response) {
              if (response.data.response) {
                alert(g.exportadoSage);
                g.exportadoSage = g.exportadoSage === 0 ? 1 : 0;
                alert(g.exportadoSage);

                vm.$notify({
                  message: vm.$t("updateExportadoSageCorrectamente"),
                  icon: "nc-icon nc-check-2",
                  timeout: 2000,
                  horizontalAlign: "right",
                  verticalAlign: "top",
                  type: "success",
                });
              } else {
                swal({
                  title: vm.$t("atencion"),
                  text: response.data.message,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });
              }
            })
            .catch(function (error) {
              console.log(error);
              vm.inProgress = false;
            });
        }
      });
    },

    eliminarGasto(g) {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        jwt: this.$store.getters.jwt,
        idHeader: g.idHeader,
        idBusiness: this.idBusiness,
      };

      let vm = this;
      let controller = "deleteExpense";
      this.axios
        .post(
          this.$store.getters.apiUrl + "gastos/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.$notify({
              message: vm.$t("gastoEliminadoCorrectamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
            let index = vm.list.findIndex(function (item) {
              return item.idHeader === g.idHeader;
            });
            if (index !== -1) {
              vm.list.splice(index, 1);
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        })
        .finally(function () {
          vm.$delete(vm.procesando, g.idHeader);
        });
    },
    openInventario(idHeader) {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idHeader: idHeader,
          idBusiness: this.idBusiness,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      let controller = "openInventario";
      this.axios
        .get(this.$store.getters.apiUrl + "gastos/" + controller, config)
        .then(function (response) {
          if (response.data.response) {
            if (response.data.result.length > 0) {
              vm.inventario.subproducts = response.data.result;
              vm.inventario.ivaIncluded = response.data.result[0].ivaIncluded;
              vm.inventario.subproducts.forEach((subproduct, index) => {
              });
            } else {
              vm.inventario.subproducts = [];
              vm.inventario.ivaIncluded = 0;
            }

            vm.$modal.show("modal-open-inventario");
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
    cerrarModal() {
      this.formaDePagoDeConversion = null;
      this.$modal.hide("modal-seleccionar-forma-pago");
      this.$modal.hide("modal-open-inventario");
      this.$modal.hide("modal-convertir-albaran");
      this.$modal.hide("modal-albaranes-de-factura");
    },
    pagar(p) {
      if (p.fromCash == 0) {
        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };
        var params = {
          jwt: this.$store.getters.jwt,
          idHeader: p.idHeader,
          pendientePago: p.pendientePago ? 0 : 1,
          idBusiness: this.idBusiness,
        };

        let vm = this;
        let controller = "changePendientePago";
        this.axios
          .post(
            this.$store.getters.apiUrl + "gastos/" + controller,
            params,
            config
          )
          .then(function (response) {
            if (response.data.response) {
              vm.$notify({
                message: vm.$t("pendientePagoCambiadoCorrectamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });

              p.pendientePago = !p.pendientePago;
              vm.getGastosNegocio();
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
            vm.inProgress = false;
          });
      }
    },
    editarVencimiento(obj) {
      this.fechaVencimiento = "";
      let fecha;
      if (parseInt(obj.dateVencimiento) > 0) {
        fecha = new Date(parseInt(obj.dateVencimiento) * 1000);
      } else {
        fecha = new Date();
      }
      this.fechaVencimiento = fecha.toISOString();
      obj.editVencimiento = !obj.editVencimiento;
    },
    saveVencimiento(obj) {
      obj.dateVencimiento = moment(this.fechaVencimiento).unix() + "";
      this.loading = Loading.service({ text: this.$t("guardandoGasto") });

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var params = {
        jwt: this.$store.getters.jwt,
        idBusiness: this.idBusiness,
        idHeader: obj.idHeader,
        dateVencimiento: obj.dateVencimiento,
      };

      let vm = this;
      let controller = "editDateVencimiento";
      this.axios
        .post(
          this.$store.getters.apiUrl + "gastos/" + controller,
          params,
          config
        )
        .then(function (response) {
          vm.loading.close();

          if (response.data.response) {
            let notify = vm.$t("actualizado");
            vm.$notify({
              message:
                vm.$t("gasto") + " " + notify + " " + vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
            obj.editVencimiento = !obj.editVencimiento;
            vm.fechaVencimiento = "";
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.loading.close();
          vm.inProgress = false;
        });
    },
    //LOLO
    closeContModal() {
      this.$modal.hide("modal-conta");
    },
    openConModal() {
      this.$modal.show("modal-conta");
    },
    exportConta() {
      let vm = this;
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      this.axios
        .get(
          this.$store.getters.apiUrl +
          "exportacionSage/getMaxIdentificadorContableByIdTpv",
          config
        )
        .then(function (response) {
          if (
            response.data.result.topId >= idStart.value.replace(".", "") &&
            response.data.result.topId >= idEnd.value.replace(".", "")
          ) {
            vm.exportCont();
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message = "El máximo identificador contable que existe es " + response.data.result.topId + " ponga el identificador contable más bajo",
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    exportCont() {
      if (
        idStart.value.replace(".", "") == "" ||
        idEnd.value.replace(".", "") == "" ||
        idStart.value.replace(".", "") == undefined ||
        idEnd.value.replace(".", "") == undefined
      ) {
        swal({
          title: vm.$t("atencion"),
          text: response.data.message,
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else if (idStart.value.replace(".", "") <= idEnd.value.replace(".", "")) {
        var config = {
          params: {
            idBusiness: this.idBusiness,
            idContableStart: idStart.value.replace(".", ""),
            idContableEnd: idEnd.value.replace(".", ""),
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        this.axios
          .get(
            this.$store.getters.apiUrl +
            "exportacionSage/exportarSAGEAsientosContablesAutomaticoByIdContable",
            config
          )
          .then(function (response) {
            download(response.data, "sage.txt", "text/plain");
          })
          .catch(function (error) {
            console.log(error);
          });

        this.$modal.hide("modal-conta");
      } else {
        swal({
          title: vm.$t("atencion"),
          text: response.data.message,
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      }
    },
  },
};
</script>

<style scoped>
p {
  list-style: none;
  line-height: 36px;
  padding: 0 20px;
  margin: 0;
  font-size: 14px;
  color: #606266;
  cursor: pointer;
  outline: none;
}

.cursor {
  color: #428bca;
  cursor: pointer;
}

.cursor:hover {
  text-decoration: underline;
}

p:hover {
  background-color: #ecf5ff;
}

a li {
  color: #111;
}

.card {
  padding: 20px;
}

.table-responsive {
  overflow-x: auto;
  max-width: 100%;
  -webkit-overflow-scrolling: touch;
}

.table-scroll-top {
  overflow-x: auto;
  overflow-y: hidden;
  max-width: 100%;
  height: 17px;
}

.table-scroll-top-inner {
  height: 1px;
}

button:disabled {
  background-color: #999999 !important;
  border-color: #777777 !important;
  color: #ffffff !important;
  cursor: not-allowed !important;
  opacity: 0.7;
}

button:disabled:hover {
  background-color: #999999 !important;
  border-color: transparent !important;
}

.btn-responsive-block {
  width: 100%;
}

@media (min-width: 768px) {
  .btn-responsive-block {
    width: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Gastos/GestionGastos.vue